import React from 'react';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenOrderDeliveryTracking from '../OpenOrderDeliveryTracking';
import { OrderManagementItem } from '../../../../../types/multiChannel/orderManagement';
import { setDash } from '../../../../../lib/common';
import type { ColumnType } from 'antd/es/table';

/**
 *  멀티채널 주문 관리 리스트 컬럼
 */
export const columns = (): ColumnType<OrderManagementItem>[] => {
  return [
    {
      title: '멀티채널 주문번호',
      dataIndex: 'id',
    },
    {
      title: '외부채널 관리번호',
      dataIndex: 'externalOrderId',
    },
    {
      title: '브랜드ID',
      dataIndex: 'brandId',
      render: (value: number) => <OpenBrandDetail text={value} storeId={value} />,
    },
    {
      title: '브랜드명',
      dataIndex: 'brandName',
      render: (value: number, row: OrderManagementItem) => (
        <OpenBrandDetail text={row.brandName} storeId={row.brandId} />
      ),
    },
    {
      title: '주문 상태',
      dataIndex: 'statusText',
    },
    {
      title: '판매처',
      dataIndex: 'multiChannelName',
      render: (value: string) => setDash(value),
    },
    {
      title: '택배사',
      dataIndex: 'deliveryEnterpriseName',
      render: (value: string) => setDash(value),
    },
    {
      title: '송장번호',
      dataIndex: 'invoiceNumber',
      render: (value: string) => setDash(value),
    },
    {
      title: '배송 조회',
      dataIndex: 'deliveryId',
      render: (value?: number) => <OpenOrderDeliveryTracking deliveryId={value} />,
    },
    {
      title: '상품ID',
      dataIndex: 'productId',
      render: (value: number) => <OpenProductDetail text={value} productId={value} />,
    },
    {
      title: '옵션ID',
      dataIndex: 'productOptionId',
      render: (value: number) => setDash(value),
    },
    {
      title: '상품명',
      dataIndex: 'productName',
      render: (value: string, row: OrderManagementItem) => (
        <OpenPreviewProductDetail text={value} productId={row.productId} />
      ),
    },
    {
      title: '옵션명',
      dataIndex: 'productOptionName',
      render: (value: string) => setDash(value),
    },
    {
      title: '스타일코드',
      dataIndex: 'productBarcode',
      render: (value: string) => setDash(value),
    },
    {
      title: '바코드',
      dataIndex: 'productOptionBarcode',
      render: (value: string) => setDash(value),
    },
    {
      title: '상품 제품번호',
      dataIndex: 'productNumber',
      render: (value: string) => setDash(value),
    },
    {
      title: '옵션 제품번호',
      dataIndex: 'productOptionNumber',
      render: (value: string) => setDash(value),
    },
    {
      title: '멀티채널 주문생성일',
      dataIndex: 'createDate',
      render: (value: string) => setDash(value),
    },
    {
      title: '수량',
      dataIndex: 'quantity',
      render: (value: number) => setDash(value),
    },
    {
      title: '주문 메시지',
      dataIndex: 'message',
      render: (value: string) => setDash(value),
    },
    {
      title: '취소 처리자',
      dataIndex: 'cancelDisposer',
      render: (value: string) => setDash(value),
    },
    {
      title: '취소 처리 일시',
      dataIndex: 'cancelledDate',
      render: (value: string) => setDash(value),
    },
    {
      title: '수취인',
      dataIndex: 'recipient',
      render: (value: string) => setDash(value),
    },
    {
      title: '수취인 연락처',
      dataIndex: 'recipientPhone',
      render: (value: string) => setDash(value),
    },
    {
      title: '배송지',
      dataIndex: 'recipientAddress',
      render: (recipientAddress: string, row: OrderManagementItem): string => {
        if (recipientAddress && row.recipientDetailAddress) {
          return `${recipientAddress} ${row.recipientDetailAddress}`;
        }

        if (recipientAddress) {
          return recipientAddress;
        }

        return '-';
      },
    },
    {
      title: '우편번호',
      dataIndex: 'recipientZipcode',
      render: (value: string) => setDash(value),
    },
  ];
};

export default columns;
